<template>
  <div class="BusinessInformation">
    <div class="top">
      <div>专利信息</div>
    </div>
    <el-form :model="ruleForm" ref="ruleForm" class="ruleForm">
      <div class="form-item">
        <div class="label">专利数量（个）</div>
        <el-form-item prop="entTel">
          <el-input
            v-model="ruleForm.patentNumber"
            type="number"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">发明专利数量（个）</div>
        <el-form-item prop="createBy">
          <el-input
            v-model="ruleForm.inventPatentNumber"
            type="number"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-upload
            :class="{ hide: isDisabled }"
            :disabled="isDisabled"
            :headers="uploadHeader"
            :action="uploadFile"
            :before-upload="beforeAvatarUploadAlone"
            :on-exceed="handleExceed"
            list-type="picture-card"
            :limit="5"
            accept=".jpg, .png, .jpeg"
            :file-list="inventPatentList"
            :on-preview="
              (file) => handlePictureCardPreview(file, 'inventPatentList')
            "
            :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'inventPatentList')
            "
            :on-success="
              (res, file, fileList) =>
                docSuccess(res, file, fileList, 'inventPatentList')
            "
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">实用新型专利数量（个）</div>
        <el-form-item prop="createBy">
          <el-input
            v-model="ruleForm.utilityModelNumber"
            placeholder="请输入"
            type="number"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-upload
            :class="{ hide: isDisabled }"
            :disabled="isDisabled"
            :headers="uploadHeader"
            :action="uploadFile"
            :before-upload="beforeAvatarUploadAlone"
            :on-exceed="handleExceed"
            list-type="picture-card"
            :limit="5"
            accept=".jpg, .png, .jpeg"
            :file-list="utilityModelList"
            :on-preview="
              (file) => handlePictureCardPreview(file, 'utilityModelList')
            "
            :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'utilityModelList')
            "
            :on-success="
              (res, file, fileList) =>
                docSuccess(res, file, fileList, 'utilityModelList')
            "
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">外观设计专利数量（个）</div>
        <el-form-item prop="createBy">
          <el-input
            type="number"
            v-model="ruleForm.designPatentNumber"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-upload
            :class="{ hide: isDisabled }"
            :disabled="isDisabled"
            :headers="uploadHeader"
            :action="uploadFile"
            :before-upload="beforeAvatarUploadAlone"
            :on-exceed="handleExceed"
            list-type="picture-card"
            :limit="5"
            accept=".jpg, .png, .jpeg"
            :file-list="designPatentList"
            :on-preview="
              (file) => handlePictureCardPreview(file, 'designPatentList')
            "
            :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'designPatentList')
            "
            :on-success="
              (res, file, fileList) =>
                docSuccess(res, file, fileList, 'designPatentList')
            "
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">国外专利数量（个）</div>
        <el-form-item prop="createBy">
          <el-input
            v-model="ruleForm.foreignPatentsNumber"
            placeholder="请输入"
            type="number"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-upload
            :class="{ hide: isDisabled }"
            :disabled="isDisabled"
            :headers="uploadHeader"
            :action="uploadFile"
            :before-upload="beforeAvatarUploadAlone"
            :on-exceed="handleExceed"
            list-type="picture-card"
            :limit="5"
            accept=".jpg, .png, .jpeg"
            :file-list="foreignPatentsList"
            :on-preview="
              (file) => handlePictureCardPreview(file, 'foreignPatentsList')
            "
            :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'foreignPatentsList')
            "
            :on-success="
              (res, file, fileList) =>
                docSuccess(res, file, fileList, 'foreignPatentsList')
            "
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </div>
    </el-form>
    <div>
      <el-button type="primary" v-if="isDisabled" @click="isDisabled = false"
        >编 辑</el-button
      >
      <el-button type="primary" v-if="!isDisabled" @click="save()"
        >保 存</el-button
      >
    </div>
    <el-image
      style="display: none"
      ref="imageView"
      :src="imageViewUrl"
      :preview-src-list="imageViewUrlList"
    >
      <template #placeholder> </template>
    </el-image>
  </div>
</template>

<script>
import {
  getPatentData,
  updatePatentData,
  uploadFile
} from '@api/corporateInteraction/enterprise'
import { getToken } from '@utils'
export default {
  name: 'PatentInformation',
  data() {
    return {
      uploadFile,
      inventPatentList: [], // 发明专利图片
      foreignPatentsList: [], // 国外专利
      designPatentList: [], // 外观设计专利
      utilityModelList: [], // 实用新型专利图片
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      imageViewUrl: '',
      imageViewUrlList: [],
      ruleForm: {},
      isDisabled: true,
      creditCode: ''
    }
  },
  mounted() {
    this.creditCode =
      this.$route.query.creditCode || this.$store.state.user.userInfo.nickName
    this.getSearch()
  },
  methods: {
    // 上传成功后
    docSuccess(res, file, fileList, key) {
      let list = []
      fileList.forEach((item) => {
        if (item.response) {
          let data = item.response.data
          list.push({
            fileName: data.fileName,
            ossUrl: data.ossUrl
          })
        } else {
          list.push({
            fileName: item.name,
            ossUrl: item.url
          })
        }
      })
      this.ruleForm[key] = list
    },
    handleRemove(file, fileList, key) {
      let list = []
      fileList.forEach((item) => {
        if (item.response) {
          let data = item.response.data
          list.push({
            fileName: data.fileName,
            ossUrl: data.ossUrl
          })
        } else {
          list.push({
            fileName: item.name,
            ossUrl: item.url
          })
        }
      })
      this.ruleForm[key] = list
    },
    handleExceed() {
      this.$message.warning('最多上传五个文件')
    },
    beforeAvatarUploadAlone(file) {
      this.isUpload = false
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
        this.isUpload = true
      }
      return isLt2M
    },
    /**
     * @description: 预览图片
     * @param {Object} row 选中表格项 {fileUrlListJson: ''}
     * @return {*}
     */
    handlePictureCardPreview(file) {
      this.imageViewUrl = file.url
      console.log(file, 'file')
      this.imageViewUrlList = [file.url]
      this.$nextTick(() => {
        this.$refs.imageView.showViewer = true // 触发图片预览功能
      })
    },
    getSearch() {
      const params = {
        creditCode: this.creditCode
      }
      getPatentData(params).then((res) => {
        if (res.data.code === '0000') {
          this.ruleForm = res.data.data
          this.inventPatentList = this.dealList(this.ruleForm.inventPatentes)
          this.foreignPatentsList = this.dealList(this.ruleForm.foreignPatentes)
          this.designPatentList = this.dealList(this.ruleForm.designPatentes)
          this.utilityModelList = this.dealList(this.ruleForm.utilityModeles)
          this.ruleForm.inventPatentList = this.dealFormList(
            this.ruleForm.inventPatentes
          )
          this.ruleForm.foreignPatentsList = this.dealFormList(
            this.ruleForm.foreignPatentes
          )
          this.ruleForm.designPatentList = this.dealFormList(
            this.ruleForm.designPatentes
          )
          this.ruleForm.utilityModelList = this.dealFormList(
            this.ruleForm.utilityModeles
          )
        }
      })
    },
    dealFormList(list) {
      let newlist = []
      list.forEach((item) => {
        newlist.push({ fileName: item.fileName, ossUrl: item.ossUrl })
      })
      return newlist
    },
    dealList(list) {
      let newlist = []
      list.forEach((item) => {
        newlist.push({ name: item.fileName, url: item.ossUrl })
      })
      return newlist
    },
    save() {
      // designPatentNumber: "12"
      // designPatentes: []
      // foreignPatentes: []
      // foreignPatentsNumber: "12"
      // inventPatentNumber: "12"
      // inventPatentes: []
      // patentNumber: "12"
      // usePatentes: []
      // utilityModelNumber: "12"
      let data = {
        designPatentNumber: this.ruleForm.designPatentNumber,
        foreignPatentsNumber: this.ruleForm.foreignPatentsNumber,
        inventPatentNumber: this.ruleForm.inventPatentNumber,
        patentNumber: this.ruleForm.patentNumber,
        utilityModelNumber: this.ruleForm.utilityModelNumber,
        inventPatentList: this.ruleForm.inventPatentList || [], // 发明专利图片
        foreignPatentsList: this.ruleForm.foreignPatentsList || [], // 国外专利
        designPatentList: this.ruleForm.designPatentList || [], // 外观设计专利
        utilityModelList: this.ruleForm.utilityModelList || [] // 实用新型专利图片
      }
      data.creditCode = this.creditCode
      updatePatentData(data).then((res) => {
        if (res.data.code == '0000') {
          this.isDisabled = true
          this.$message.success('修改成功')
          document.getElementsByClassName('app-container')[0].scrollTop = 0
          // this.getSearch()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
}
/deep/.hide .el-upload-list__item-status-label {
  display: none;
}
.BusinessInformation {
  padding-bottom: 20px;
  .top {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .business-content {
    margin-top: 20px;
    height: auto;
  }
  .form-item {
    // display: inline-block;
    font-size: 14px;
    color: #000;
    /deep/.el-input {
      width: 20%;
    }
    // width: 50%;
    .label {
      margin-bottom: 8px;
    }
    /deep/.el-input.is-disabled .el-input__inner {
      background-color: #fff;
      border-color: #dfe4ed;
      color: #000;
    }
  }
}
</style>
